import IconWarning from '../../../../../../../components/icons/icon-warning/icon-warning';
import { Button } from '../../../../../../../components/inputs/button/button';
import FontHeading3 from '../../../../../../../components/fonts/font-heading3/font-heading3';
import FontBody2 from '../../../../../../../components/fonts/font-body2/font-body2';
import { BUTTON_VARIANTS } from '../../../../../../../components/inputs/button-variants';
import { FONT_COLOR, FONT_VARIANT } from '../../../../../../../components/fonts/font-props';

import { IRefundCalculatorResponseDto } from '../../../refund-calculator-types';

import './calculator-header.scss';
import { decimalFormat } from '../../../../../../../services/helpers';

interface ICalculatorHeaderProps {
    data: IRefundCalculatorResponseDto;
    onCopyJson: () => void;
}

const CalculatorHeader: React.FC<ICalculatorHeaderProps> = ({ data, onCopyJson }) => {
    return (
        <div className="refund-calculator__header">
            <div className="refund-calculator__header-title">
                <div className="refund-calculator__header-title-left">
                    <FontHeading3 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>RMA{data.rma_id} | Order {data.order_name}</FontHeading3>
                    {data.is_bxgy ? (
                        <div className="refund-calculator__header-title-warning badge badge-warning">
                            <IconWarning color="var(--color-semantic-warning)" />
                            <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>BxGy</FontBody2>
                        </div>
                    ) : null}
                </div>
                <div className="refund-calculator__header-title-right">
                    <Button
                        text="Copy JSON"
                        variant={BUTTON_VARIANTS.PrimaryAccent}
                        onClick={onCopyJson}
                    />
                </div>
            </div>
            <div className="card">
                <div className="refund-calculator__header-content">
                    <div className="refund-calculator__header-content-left">
                        <div className="content-item">
                            <FontBody2 color={FONT_COLOR.PRIMARY2}>
                                Order currency conversion rate
                            </FontBody2>
                            <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
                                {Number(decimalFormat(data.currencies.order_currency_conversion_rate, 4))}
                            </FontBody2>
                        </div>
                        <div className="content-item">
                            <FontBody2 color={FONT_COLOR.PRIMARY2}>
                                Return currency conversion rate
                            </FontBody2>
                            <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
                                {Number(decimalFormat(data.currencies.return_currency_conversion_rate, 4))}
                            </FontBody2>
                        </div>
                        {data.currencies?.manual_rate ? (
                            <div className="content-item">
                                <FontBody2 color={FONT_COLOR.PRIMARY2}>
                                    Manual conversion rate
                                </FontBody2>
                                <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
                                    {Number(decimalFormat(data.currencies.manual_rate, 4))}
                                </FontBody2>
                            </div>
                        ) : null}
                    </div>
                    <div className="refund-calculator__header-content-right">
                        <div className="content-item">
                            <FontBody2 color={FONT_COLOR.PRIMARY2}>
                                Shop Money
                            </FontBody2>
                            <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
                                {data.currencies.shop_currency_code}
                            </FontBody2>
                        </div>
                        <div className="content-item">
                            <FontBody2 color={FONT_COLOR.PRIMARY2}>
                                Presentment Money
                            </FontBody2>
                            <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
                                {data.currencies.payment_currency_code}
                            </FontBody2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CalculatorHeader;
